import { getTicketing, postTicketing } from '@Src/apiServices/baseService';
import { UploadFile } from 'antd';
import { CreateTicketApiType } from '@Src/commons/Ticketing/types';
import {
  TICKET_COMMENTING_URL,
  TICKET_LISTING_URL,
  TICKETING_URL,
} from '@Src/commons/ConstantUrls';
import fetchWithTimeout from './fetchWithTimeout';

function getTimeLimit(fileSize: number | undefined) {
  let timeLimit = 1000;
  if (fileSize === undefined) {
    return timeLimit;
  }
  // Convert to MB
  fileSize = fileSize / 1024 / 1024;
  if (fileSize < 2) {
    timeLimit = 2000;
  } else if (fileSize < 5) {
    timeLimit = 5000;
  } else if (fileSize < 10) {
    timeLimit = 10000;
  } else if (fileSize < 15) {
    timeLimit = 15000;
  } else {
    timeLimit = 20000;
  }
  return timeLimit;
}

export async function createTicketApi(
  data: CreateTicketApiType,
  appSource: string
) {
  return postTicketing({
    url: TICKETING_URL,
    appSource,
    data,
  });
}

export async function uploadFileApi(url: string, file: UploadFile) {
  return fetchWithTimeout(url, {
    method: 'PUT',
    body: file,
  });
}

export async function getTicketListApi(
  params: Record<string, string>,
  appSource: string
) {
  return getTicketing(
    {
      params,
      appSource,
    },
    TICKET_LISTING_URL
  );
}

export async function searchApi(
  params: Record<string, string>,
  appSource: string,
  autocomplete = false
) {
  if (autocomplete) {
    params.autocomplete = true;
  }
  return getTicketListApi(params, appSource);
}

export async function getTicketDetailsApi(ticketId: string, appSource: string) {
  return getTicketing(
    {
      params: ticketId,
      appSource,
    },
    TICKET_LISTING_URL
  );
}

export async function createCommentApi(data: any, appSource: string) {
  return postTicketing({
    url: TICKET_COMMENTING_URL,
    appSource,
    data,
  });
}

export async function fetchCommentsApi(data: any, appSource: string) {
  return getTicketing(
    {
      params: data,
      appSource,
    },
    TICKET_COMMENTING_URL
  );
}

export async function uploadCommentAttachmentApi(
  url: string,
  file: UploadFile,
  fileName: string,
  metadata: { comment_details: any }
) {
  const { size } = file;

  const fileUploadPromise = await fetchWithTimeout(
    url,
    {
      method: 'PUT',
      headers: {
        'x-amz-meta-comment_details': metadata.comment_details,
      },
      body: file,
    },
    getTimeLimit(size)
  );

  return fileUploadPromise;
}
